import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-pillar-ops",
  "use": "icon-soc-pillar-ops-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-pillar-ops\">\r\n  <!-- ③ SOC运营：店面／决策台线框 -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <path d=\"M192 384l128-160h384l128 160\" />\r\n    <path d=\"M224 384h576v384H224z\" />\r\n    <path d=\"M320 576h384M384 704h192\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-pillar-ops.svg
// module id = czPO
// module chunks = 477